import { render, staticRenderFns } from "./editMulti.vue?vue&type=template&id=c9a6904a"
import script from "./editMulti.vue?vue&type=script&lang=js"
export * from "./editMulti.vue?vue&type=script&lang=js"
import style0 from "./editMulti.vue?vue&type=style&index=0&id=c9a6904a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports